import { Model } from '../../model/model';
import { Matrix } from '@wizeoo/akm-message-lib';
import { MatrixVO } from '../../vo/matrix/matrix.vo';

/**
 * contrat d'appel pour lecture des matrices Dexie
 */
export interface MatrixCallParam {
  widgetCell: any; // cellule source si appel depuis une formule
  targetColumn: string; // nom de la colonne cible
  datakind: string; // type de mesure recherchée pour cast correct
  query: string; // requête dexie
  result: any[]; // lignes dataMatrix en retour
}

/**
 * Manager des matrices de données
 */
export class MatrixEngine {

  protected _model: Model = null;
  constructor(model: Model) {
    this._model = model;
  }
  public get model(): Model {
    return this._model;
  }

  public reset(): void {
    this._model.workcomList = null;
    this._model.workcomMap = null;
  }

  /**
   * Récupération d'une matrice par son code
   * @param code Le code de la matrice
   */
  public getMatrix(code: string): MatrixVO {
    let m: MatrixVO = null;
    if (this.model.matrixMap && this.model.matrixMap.get(this.model.businessUnitCode)) {
      m = this.model.matrixMap.get(this.model.businessUnitCode).get(code);
    }
    return m;
  }

  /**
   * suppression de l'instance d'un matrixVO
   * @param code Le code de la matrice
   */
  public removeMatrix(code: string): void {
    const toDie: MatrixVO = this.getMatrix(code);
    this.model.matrixList.splice(this.model.matrixList.indexOf(toDie), 1);
    this.model.matrixMap.get(this.model.businessUnitCode).delete(code);
  }

  /**
   * ajout de l'instance d'un matrixVO
   * @param vo matrixVO
   */
  public addMatrix(vo: MatrixVO): void {
if (!this._model.matrixList) {
            this._model.matrixList = [];
        }
        this._model.matrixList.push(vo);
        if (!this.getMatrixMap()) {
            this.setMatrixMap(new Map<string, Map<string, MatrixVO>>());
        }
        if (!this.getMatrixMap().has(vo.businessUnitCode)) {
            this.getMatrixMap().set(vo.businessUnitCode, new Map<string, MatrixVO>());
        }
        this.getMatrixMap().get(vo.businessUnitCode).set(vo.code, vo);    
  }

    public newMatrixVO(source?: Matrix): MatrixVO {
        return new MatrixVO(this.model, source);
    }

    public getMatrixList(): MatrixVO[] {
        return this._model.matrixList;
    }

    public getMatrixMap(): Map<string, Map<string, MatrixVO>> {
        return this._model.matrixMap;
    }
    
    public setMatrixMap(map: Map<string, Map<string, MatrixVO>>) {
        this._model.matrixMap = map;
    }

    /**
     * Alimentation des matrices du modèle
     * @param matrix: Matrix[]
     */
    public feedMatrix(matrix: Matrix[]): void {
        const flatList: MatrixVO[] = matrix.map((f) => this.newMatrixVO(f));

        if (this._model.matrixList == null || this._model.matrixList.length === 0) {
            flatList.forEach((fvo: MatrixVO) => {
                this.addMatrix(fvo);
            });
        } else {
            flatList.forEach((fvo: MatrixVO) => {
                const fvoIndex = this._model.matrixList.findIndex(element => element.code === fvo.code);
                if (fvoIndex < 0) {
                    this.addMatrix(fvo);
                } else {
                    this._model.matrixList[fvoIndex] = fvo;
                    this.getMatrixMap().get(fvo.businessUnitCode).set(fvo.code, fvo);
                }
            });
        }
    }

  /**
   * exécution de requêtes Dexie sur la table des matrices
   * @param widgetCell (widgetCell) la cellule cible pour le résultat
   * @param targetColumn la colonne cible
   * @param datakind: string type pour cast
   * @param query 
   * @returns 
   */
  public async runQuery(widgetCell: any, targetColumn: string, datakind: string, query: string): Promise<MatrixCallParam> {
    return null;
  }
}
